// Minimal locale utilities — extended by the locale prompt.

/**
 * Extracts the base language code from a locale string.
 * 'en-GB' → 'en', 'sk' → 'sk', 'cs-CZ' → 'cs'
 */
export function getLanguageCode(locale: string): string {
  return locale.split('-')[0].toLowerCase()
}
